import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetFinanceTradesHistoryRequestModel,
    GetFinanceTradesHistoryResponseModel,
} from "@/features/accounts/finance/services/get-trades-history-model";

export class GetFinanceTradesHistoryApi {
    /**
     * 銀行取込履歴取得API
     */
    public getFinanceTradesHistory = async (
        param: GetFinanceTradesHistoryRequestModel,
    ): Promise<GetFinanceTradesHistoryResponseModel> => {
        const path = `/api/financeaccounts/finances/tradeshistory`;
        const res = await ApiClient.instance.get<GetFinanceTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
